// extracted by mini-css-extract-plugin
export default {"playerContainer":"Video_playerContainer__eLIqJ","playerBackdrop":"Video_playerBackdrop__64qxd"};